import { useEffect, useState } from "react";
import { GetAdminDashboardDataAction } from "../../../store/Actions/adminActions";
import { useReduxStore } from "../../../hooks/useReduxStore";

const useAdminDashboard = () => {
  const { getState, dispatch } = useReduxStore();
  
  // Get admin dashboard data from store
  const { dashboardData, analytics, loading } = getState("ADMIN_DASHBOARD");
  const { isAdminLoggedIn, adminData } = getState("ADMIN_AUTH");
const [showCreateUserModal,setShowCreateUserModal]=useState(false)
const [showApiKeyModal,setShowApiKeyModal]=useState(false)
const onCloseModal=()=>{
  showCreateUserModal(false)
}
  // Fetch dashboard data on component mount
  useEffect(() => {
    // console.log("useEffect--------",isAdminLoggedIn)

      // console.log("isAdminloginnn--------")
      dispatch(GetAdminDashboardDataAction({}));
  }, []);

  return {
    dashboardData,
    analytics,
    loading,
    isAdminLoggedIn,
    adminData,
    setShowCreateUserModal,
    onCloseModal,
    showApiKeyModal,
    setShowApiKeyModal,
    showCreateUserModal,
  };
};

export default useAdminDashboard;
